import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import axios from 'axios'
import Swal from 'sweetalert2'
import React from 'react'
import { get as _get } from 'lodash'
import { useKeycloak } from "react-keycloak"
import { showError } from "../../utils/sweetAlertHelper";

const getColor = (props: any) => {
    if (props.isDragAccept) {
        return '#00e676'
    }
    if (props.isDragReject) {
        return '#ff1744'
    }
    if (props.isDragActive) {
        return '#2196f3'
    }
    return '#eeeeee'
}

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border 0.24s ease-in-out;
    margin-bottom: 20px;
`

interface DropZoneProps {
    url: string
    accept: string | string[]
}

export const UploadDropzone: React.FC<DropZoneProps> = (props: DropZoneProps) =>  {
    const { url, accept } = props
    const [keycloak] = useKeycloak()

    const handleOnDrop = (acceptedFiles: any) => {
        const uploaders = acceptedFiles.map((file: any) => {
            const formData = new FormData()
            formData.append('file', file)

            return axios
                .post(url, formData, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        Authorization: keycloak.token ? `Bearer ${keycloak.token}` : '',
                    },
                })
                .then((response: any) => {
                    const { data } = response
                    Swal.fire({
                        title: 'SUCCESS',
                        text: 'Data is being sucessfully uploaded and processed now.',
                        icon: 'success',
                        confirmButtonText: 'Ok',
                    })
                }).catch((reason: any) => {
                    const payload = reason.response.data
                    const message = _get(payload, 'error.message', '')
                    const title = `${_get(payload, 'error.code', '')}`
                    showError(message, title)
                })
        })
    }

    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
        accept,
        onDrop: files => handleOnDrop(files),
    })

    return (
        <div className="container">
            <Container {...getRootProps({ className: 'dropzone', isDragActive, isDragAccept, isDragReject })}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </Container>
        </div>
    )
}
